














import {Component, Vue, Watch} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {BreadcrumbContext} from '@/store/storeStateInterface';
import {buildBreadcrumbs, BreadcrumbItem} from '@/misc/breadcrumbUtils';

const SettingsStore = namespace('settings');

@Component({})
export default class BreadcrumbsComponent extends Vue {

  @SettingsStore.Getter('breadcrumbContext')
  public breadcrumbContext!: BreadcrumbContext;

  @SettingsStore.Mutation('setCurrentTitle')
  public setCurrentTitle!: (title: string) => void;

  public items: BreadcrumbItem[] = [];

  public mounted() {
    this.updateBreadcrumbs();
  }

  @Watch('$route')
  public onRouteChanged() {
    this.updateBreadcrumbs();
  }

  @Watch('breadcrumbContext', { deep: true })
  public onContextChanged() {
    this.updateBreadcrumbs();
  }

  public updateBreadcrumbs() {
    this.items = buildBreadcrumbs(this.$route, this.breadcrumbContext);

    const lastItem = this.items[this.items.length - 1];
    if (lastItem) {
      this.setCurrentTitle(lastItem.text);
    }
  }
}
